import { initSheetID } from "./sheet.js";
import { renderApp } from "./App.jsx";

window.addEventListener("load", async function () {
  initSheetID();
  renderApp();
});
